export default "__VITE_ASSET__B7uKx_Dz__"